module.exports = __webpack_public_path__ + "static/metro-pmt_dash-e76453f6b9e89b1b8b5043d0e1dbe327.png";